<template>
	<div class="my-order-page">
		<!-- ===== 标题栏 ===== -->
		<div class="page-header animate__animated  ">
			<el-image :src="require('@/static/CodeBuddyAssets/31270_3509/24.svg')"></el-image>
			<span class="header-title">{{$t('userPageL.txt5')}}</span>
		</div>

		<!-- ===== Tab 切换栏 ===== -->
		<div class="tab-bar animate__animated  ">
			<div
				v-for="(tab, index) in tabs"
				:key="index"
				class="tab-item"
				:class="{ 'tab-item--active': activeTab === index }"
				@click="activeTab = index,orderListF()"
			>
			<!-- -2 0 1 2 3 4 5 -1 -->
			<template v-if="index==0">{{$t('olist.all')}}</template>
			<template v-if="index==1">{{$t('myShopOrder.t1')}}</template>
			<template v-if="index==2">{{$t('myShopOrder.t2')}}</template>
			<template v-if="index==3">{{$t('myShopOrder.t3')}}</template>
			<template v-if="index==4">{{$t('myShopOrder.t4')}}</template>
			<template v-if="index==5">{{$t('myShopOrder.t5')}}</template>
			<template v-if="index==6">{{$t('myShopOrder.t6')}}</template>
			<template v-if="index==7">{{$t('myShopOrder.t7')}}</template>
			</div>
		</div>

		<!-- ===== 搜索筛选区 ===== -->
		<div class="filter-bar animate__animated  ">

			<div class="filter-items">
				
				<div class="filter-month f-ct">
					<el-select @change="orderListF" v-model="warehouseIdx" :placeholder="$t('shopOrder.t18')" class="form-select">
						<el-option v-for="item in warehouseArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
					<el-image :src="require('@/static/sel/15.svg')"></el-image>
				</div>
				
				<div class="shaixuanFrom f-bct">
					<div class="iptBox">
						<el-image :src="require('@/static/sel/6.svg')"></el-image>
						<el-input v-model="query" :placeholder="$t('olist.t40')"></el-input>
					</div>
					<div class="action-bar1">
						<el-button type="primary" class="submit-btn" @click="orderListF">{{$t('olist.t2')}}</el-button>
					</div>
				</div>
				

				<!-- 下单时间范围 -->
				<div class="filter-date">
					<span class="date-label">{{$t('olist.t3')}}</span>
					<el-date-picker
						@change="orderListF"
						value-format="yyyy-MM-dd"
						v-model="searchForm.dateRange"
						type="daterange"
						range-separator="-"
						:start-placeholder="$t('olist.t4')"
						:end-placeholder="$t('olist.t4')"
						prefix-icon=" "
					></el-date-picker>
					<el-image :src="require('@/static/sel/14.svg')"></el-image>
				</div>

				<!-- 月份选择 -->
				<!-- <div class="filter-month f-ct">
					<el-select @change="orderListF" v-model="searchForm.month">
						<el-option :label="$t('olist.t5')" value="0"></el-option>
						<el-option label="1月" value="1"></el-option>
						<el-option label="2月" value="2"></el-option>
						<el-option label="3月" value="3"></el-option>
						<el-option label="4月" value="4"></el-option>
						<el-option label="5月" value="5"></el-option>
						<el-option label="6月" value="6"></el-option>
						<el-option label="7月" value="7"></el-option>
						<el-option label="8月" value="8"></el-option>
						<el-option label="9月" value="9"></el-option>
						<el-option label="10月" value="10"></el-option>
						<el-option label="11月" value="11"></el-option>
						<el-option label="12月" value="12"></el-option>
					</el-select>
					<el-image :src="require('@/static/sel/15.svg')"></el-image>
				</div> -->
				
			</div>
		</div>

		<!-- ===== 数据表格 (Element UI) ===== -->
		<div class="table-wrap newTable animate__animated  " v-if="1">
			<div class="title f-ct">
				<div class="t1">{{$t('myShopOrder.t8')}}</div>
				<div class="t2">{{$t('myShopOrder.t9')}}</div>
				<div class="t4">{{$t('myShopOrder.t10')}}</div>
				<div class="t5">{{$t('myShopOrder.t11')}}</div>
				<div class="t6">{{$t('myShopOrder.t12')}}</div>
			</div>
			<div class="goodsItem" v-for="(item,index) in orderList">
				<div class="topBox f-ct">
					<div class="sn f-ct">
						<p>{{$t('olist.t33')}}{{item.orderNo}}</p>
						<el-image @click="copy_txt(item.orderNo)" :src="require('@/static/add2/51.png')"></el-image>
					</div>
					<div class="time">{{$t('myShopOrder.t13')}}{{item.warehouseName}}</div>
				</div>
				<div class="gmsg f-ct">
					<div class="b1">
						<template v-for="(item,index) in item.shopGroups">
						<div class="goodsMsg" v-for="(gitm,gidx) in item.goodsList">
							<div class="table-body">
								<el-image class="product-img" :src="gitm.picUrl" :preview-src-list="[gitm.picUrl]" fit="cover"></el-image>
								<div class="product-info">
									<div class="table-header-row">
										<div class="store-tag tag-blue" v-if="item.channelType==1">
											<span>{{$t('shopCar.t4')}}</span>
										</div>
										<div class="store-tag tag-red" v-if="item.channelType==2">
											<span>1688</span>
										</div>
										<div class="store-tag tag-orange" v-if="item.channelType==3">
											<span>{{$t('shopIndex.t16')}}</span>
										</div>
										<div class="store-tag tag-red" v-if="item.channelType==4">
											<span>{{$t('shopIndex.t15')}}</span>
										</div>
										<el-image class="store-avatar" :src="require('@/static/CodeBuddyAssets/30862_3378/10.svg')"></el-image>
										<span class="store-name-text">{{item.merchantName}}</span>
									</div>
									<div class="product-name">{{gitm.goodsName}}</div>
									<div class="product-spec">{{gitm.specifications.join(' ')}}&emsp;x{{gitm.number}}</div>
								</div>
							</div>
						</div>
						</template>
					</div>
					<div class="b2">{{item.createTime||'?'}}</div>
					<div class="b4">￥{{item.actualPrice||'?'}}</div>
					<div class="b5" v-if="item.orderStatus==0">{{$t('myShopOrder.t1')}}</div>
					<div class="b5" v-if="item.orderStatus==1">{{$t('myShopOrder.t2')}}</div>
					<div class="b5" v-if="item.orderStatus==2">{{$t('myShopOrder.t3')}}</div>
					<div class="b5" v-if="item.orderStatus==3">{{$t('myShopOrder.t4')}}</div>
					<div class="b5" style="color:#999;" v-if="item.orderStatus==4">{{$t('myShopOrder.t5')}}</div>
					<div class="b5" style="color:#999;" v-if="item.orderStatus==5">{{$t('myShopOrder.t6')}}</div>
					<div class="b5" style="color:#999;" v-if="item.orderStatus==-1">{{$t('myShopOrder.t7')}}</div>
					<div class="b6">
						<div class="btn1" v-if="item.orderStatus == 0" @click="link('/userPageLab/myShopPay',{id:item.id})">{{$t('olist.t39')}}</div>
						<div class="btn2" v-if="item.orderStatus == 0" @click="deleteOrder(item)">{{$t('olist.t25')}}</div>
						<div class="btn3" @click="link('/userPageLab/myShopOrderMsg',{id:item.id})">{{$t('shopOrder.t15')}}</div>
					</div>
				</div>
			</div>
		</div>

		<!-- ===== 分页 ===== -->
		<div class="pagination-wrap animate__animated  ">
			<el-pagination
				background
				layout="prev, pager, next, jumper"
				:total="total"
				:page-size="pageSize"
				:current-page.sync="currentPage"
				@current-change="handleCurrentChange"
			></el-pagination>
		</div>

		<!-- ===== 取消订单弹出框 ===== -->
		<el-dialog
			:visible.sync="addMarkVisibleDel"
			width="464px"
			custom-class="add-mark-dialog"
			:show-close="false"
			:close-on-click-modal="false">
			<!-- 自定义头部 -->
			<div slot="title" class="dialog-header">
				<h2 class="dialog-title">{{$t('olist.hb1')}}</h2>
				<el-image class="dialog-close-icon" :src="require('@/static/sel/20.svg')" @click="addMarkVisibleDel = false"></el-image>
			</div>
			<div class="dialog-title1">
				{{$t('myShopOrder.t14')}}
			</div>
			<!-- 底部按钮区 -->
			<div slot="footer" class="dialog-footer">
				<button class="btn-cancel" @click="addMarkVisibleDel = false">{{$t('olist.hb5')}}</button>
				<button class="btn-confirm" @click="transportOrderremoveByIdF">{{$t('omsg.t39')}}</button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
import {
	orderlist,
	ordercancel,
	warehouselist,
} from "/src/api/api.js"
export default {
	name: 'MyOrderPage',
	inject: ['reload'],
	data() {
		return {
			// 状态
			activeTab: 0,
			// 搜索
			query:'',
			searchForm: {
				dateRange: '',
				month: '0'
			},
			// 仓库
			warehouseArr:[],
			warehouseIdx:0,
			// 分页
			currentPage: 1,
			pageSize: 10,
			total: 250,
			// 数据
			orderList: [],
			// 弹出框所选数据
			selItem:'',
			// 弹出框 删除
			addMarkVisibleDel:false,
		}
	},
	computed: {
		tabs() {
			return [
				this.$t('olist.all'),
				this.$t('myShopOrder.t1'),
				this.$t('myShopOrder.t2'),
				this.$t('myShopOrder.t3'),
				this.$t('myShopOrder.t4'),
				this.$t('myShopOrder.t5'),
				this.$t('myShopOrder.t6'),
				this.$t('myShopOrder.t7'),
			]
		}
	},
	mounted() {
		if(this.$route.query.status){
			this.activeTab = this.$route.query.status*1
		}
		this.warehouselistGet()
	},
	methods: {
		// 仓库列表(全部正常的)
		async warehouselistGet(){
			var data = {}
			const res = await warehouselist(data)
			if(res.code==200){
				(res.rows || []).forEach(item => {
					item.label = item.name
					item.value = item.id
				})
				this.warehouseArr = [{
					label : this.$t('olist.all'),
					value : -1
				},...res.rows]
				this.warehouseIdx = -1
				this.orderListF()
			}else{this.Tips(res.msg,'error')}
		},
		// 订单列表
		async orderListF(){
			var res;
			var data = {
				pageNum: this.currentPage,
				pageSize: this.pageSize,
			}
			if(this.warehouseIdx!=-1){
				data.warehouseId = this.warehouseIdx
			}
			if(this.query){
				data.orderNo = this.query
			}
			if(this.activeTab){
				if(this.activeTab==7){
					data.orderStatus = -1
				}else{
					data.orderStatus = this.activeTab*1-1
				}
			}
			if(this.searchForm.month*1){
				var str = ''
				if(this.searchForm.month<10){
					str = '0'+this.searchForm.month
				}
				const utcYear = new Date().getUTCFullYear();
				str = utcYear+'-'+str
				data.queryMonth = str
			}
			if(this.searchForm.dateRange){
				data.beginTime = this.searchForm.dateRange[0]
				data.endTime = this.searchForm.dateRange[1]
			}
			res = await orderlist(data);
			if(res.code==200){
				this.total = res.total
				this.orderList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 切换分页
		handleCurrentChange(page) {
			this.currentPage = page
			this.orderListF()
		},
		// 取消按钮
		deleteOrder(item) {
			this.selItem = item
			this.addMarkVisibleDel = true
		},
		async transportOrderremoveByIdF(){
			var res;
			res = await ordercancel({
				orderId:this.selItem.id,
			});
			if(res.code==200){
				this.addMarkVisibleDel = false
				this.Tips(res.msg)
				this.orderListF()
			}else{this.Tips(res.msg,'error')}
		},
	}
}
</script>

<style lang="scss" scoped>
::v-deep .cell{
	flex-wrap: wrap;
}
/* ========== 设计令牌 ========== */
$primary: #0096FF;
$danger: #FC2933;
$text-dark: #333333;
$text-gray: #666666;
$text-muted: #999999;
$text-light: #7D7D89;
$border-color: #F0F0F0;
$page-bg: white;
$header-bg: #FAFAFA;

/* ========== 页面容器 ========== */
.my-order-page {
	width: 15.93rem;           /* 1593px */
	background: $page-bg;
	border-radius: 12px;
	padding: 24px 25px 30px;  /* left:316=292+24 */
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	margin-top: 24px;
}

/* ========== 标题栏 ========== */
.page-header {
	display: flex;
	align-items: center;
	margin-bottom: 22px;       /* 到 tab 的间距 ≈ 160+24-160≈24 */

	.header-icon {
		width: 14px;
		height: 14px;
		flex-shrink: 0;
	}

	.header-title {
		font-size: 20px;
		font-weight: 500;
		color: $text-dark;
		margin-left: 12px;
	}
}

/* ========== Tab 栏 ========== */
.tab-bar {
	display: flex;
	align-items: center;
	// gap: 72px;               /* tab 间距 ≈ 418-328=90，取合理值 */
	// padding-bottom: 16px;
	border-bottom: 1px solid #F5F5F5;
	margin-bottom: 18px;      /* 到筛选区的间距 */

	.tab-item {
		font-size: 18px;
		font-weight: 400;
		color: $text-light;
		cursor: pointer;
		transition: color 0.2s;
		white-space: nowrap;
		padding: 0 24px;
		padding-bottom: 16px;
		position: relative;
		// background: pink;
		margin-right: 24px;
		&::after{
			position: absolute;
			content: '';
			width: 0%;
			height: 4px;
			background: #0096FF;
			border-radius: 4px;
			left: 49%;
			transform: translateX(-50%);
			bottom: 0;
			transition:0.3s;
		}
		&:hover { color: $primary; }

		&--active {
			color: $primary;
			&::after{
				transition:0.3s;
				width: 35%;
			}
			font-weight: bold;
		}
	}
}

/* ========== 筛选栏 ========== */
.filter-bar {
	display: flex;
	align-items: center;
	margin-bottom: 24px;      /* 到表格的间距 = 346-(250+38+50)=8... 实际约24px */

	.filter-icon {
		width: auto;
		height: 26px;
		flex-shrink: 0;
		margin-right: 15px;
		margin-top: 13px;
	}

	.filter-items {
		display: flex;
		align-items: center;
		gap: 16px;            /* 各筛选项间距 */
		flex: 1;
	}
}

/* ---- 输入框 ---- */
.filter-inp {
	width: 652px;
	flex-shrink: 0;
	
		
	::v-deep .el-input {
		width: 100%;
	}

	::v-deep .el-input__inner {
		height: 50px;
		line-height: 48px;
		border-radius: 8px;
		border: none;
		background: #FAFAFA;
		font-size: 16px;
		padding: 0 20px;
		color: #333;
		
		&::placeholder { color: #A0AEC0; letter-spacing: 0.48px; }

		&:focus { background: #F5F5F5; }

		.el-input__prefix { left: 20px; }
		
	}
}

/* ---- 日期范围选择器 ---- */
.filter-date {
	width: 468px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	background: #f8f8f8;
	border-radius: 8px;
	height: 50px;
	padding: 0 20px;
	box-sizing: border-box;
	// background: pink;
	.date-label {
		font-size: 16px;
		color: #989FAC;
		letter-spacing: 0.48px;
		margin-right: 4px;
		white-space: nowrap;
		flex-shrink: 0;
	}
	
	.el-image{
		width: 20px;
	}

	::v-deep .el-date-editor {
		width: calc(100% - 84px);
		border: none !important;
		background: #f8f8f8;
	}

	::v-deep .el-range-input {
		font-size: 16px;
		color: #333;
		background: transparent;
		width: 110px;

		&::placeholder { color: #989FAC; }
	}

	::v-deep .el-range-separator {
		color: #333;
		width: auto;
		padding: 0 8px;
	}

	::v-deep .el-range__icon,
	::v-deep .el-range__close-icon {
		display: none;
	}

	::v-deep .el-range-editor--medium {
		height: 50px;
	}
}

/* ---- 月份选择器 ---- */
.filter-month {
	width: 235px;
	flex-shrink: 0;
	background: #f8f8f8;
	border-radius: 8px;
	// background: pink;
	::v-deep .el-select {
		width: calc(100% - 40px);
		
		.el-input__inner {
			height: 50px;
			line-height: 48px;
			border-radius: 8px;
			border: none;
			background: #f8f8f8;
			font-size: 16px;
			color: #333;
			padding: 0 35px 0 20px;
			letter-spacing: 0.48px;
			// background: pink;
		}

		.el-input__suffix {
			right: 20px;
		}

		.el-select__caret {
			width: 12px;
			height: 8px;
			&::before { content: none; }
		}

		.el-select__icon {
			width: 12px;
			height: 8px;
			// background: url(~@/static/CodeBuddyAssets/31200_3663/31.svg) no-repeat center/contain;
		}
	}
}

/* ---- 搜索按钮 ---- */
.search-btn {
	width: 116px;
	height: 50px;
	flex-shrink: 0;
	background: $primary;
	border: none;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 400;
	color: white;
	letter-spacing: 0.48px;
	cursor: pointer;
	transition: opacity 0.25s;

	&:hover { opacity: 0.88; }
	&:active { opacity: 1; }
}

/* ========== 表格区域 (Element UI) ========== */
.table-wrap {
	width: 100%;
}

::v-deep .el-table {
	border-radius: 8px;
	overflow: hidden;

	th.el-table__cell,
	td.el-table__cell {
		padding: 0;
	}
}

/* ---- 表头样式 ---- */
::v-deep .order-table-header {
	background-color: $header-bg !important;
	height: 56px !important;
	font-size: 14px !important;
	font-weight: 500 !important;
	color: $text-dark !important;

	.cell {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 56px;
		line-height: normal;
	}
}

/* ---- 单元格样式 ---- */
::v-deep .order-table-cell {
	height: 56px !important;
	font-size: 14px !important;
	font-weight: 400 !important;
	color: $text-gray !important;

	.cell {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 56px;
		line-height: normal;
	}
}

/* ---- 操作列内容 ---- */
.cell-action {
	// display: flex;
	// justify-content: center;
	// align-items: center;
	// flex-wrap: wrap;
	// gap: 10px;
	span{
		display: block;
		margin-bottom: 8px;
		&:last-child{
			margin-bottom: 0;
		}
	}
}
::v-deep  .order-table-cell .cell{
	height: auto;
}
.act-view,
.act-edit,
.act-del {
	font-size: 14px;
	cursor: pointer;
	white-space: nowrap;
	transition: opacity 0.2s;

	&:hover { opacity: 0.7; }
}

.act-view { color: $primary; }
.act-edit { color: $primary; }
.act-del { color: $danger; }
.act-def { color: #333; }
.act-defH { color: #999; }

/* ========== 分页（复制 latestNews.vue） ========== */
.pagination-wrap {
	display: flex;
	justify-content: flex-end;
	padding-top: 20px;
	padding-right: 10px;

	::v-deep .el-pagination__editor { margin-right: 12px; }

	::v-deep .el-pagination {
		font-weight: 400;

		.el-pager li {
			min-width: 32px;
			height: 32px;
			line-height: 32px;
			font-size: 12px;
			border-radius: 4px;
			margin: 0 4px;
			color: #2C2C2C;

			&.active {
				background: transparent;
				color: $primary;
				border-color: transparent;
				font-weight: 600;
			}

			&:hover { color: $primary; }
		}

		.btn-prev,
		.btn-next {
			min-width: 32px;
			height: 32px;
			line-height: 32px;
			font-size: 12px;
			border-radius: 4px;

			&:hover { color: $primary; }
		}

		.el-pagination__jump {
			font-size: 12px;
			color: #2C2C2C;
			margin-left: 12px;

			.el-input__inner {
				width: 36px;
				height: 32px;
				line-height: 30px;
				font-size: 12px;
				border-radius: 4px;
				text-align: center;
				padding: 0;

				&:focus { border-color: $primary; }
			}
		}
	}
}

::v-deep .el-pagination.is-background .el-pager li { background: transparent; }
::v-deep .el-pagination.is-background .btn-prev { background: transparent; }
::v-deep .el-pagination.is-background .btn-next { background: transparent; }
::v-deep .el-table th.el-table__cell>.cell { 
	display: flex;
}

.item-thumb{
	width: 36px;
	height: 36px;
	border-radius: 6px;
}

@media (prefers-reduced-motion: reduce) {
	.animate__animated { animation: none !important; }
	* { transition-duration: 0.01ms !important; }
}
.shaixuanFrom{
	// margin-bottom: 12px;
	.iptBox{
		width: 652px;
		height: 50px;
		border-radius: 8px;
		background: #f8f8f8;
		// background: pink;
		padding: 0 20px;
		display: flex;
		align-items: center;
		margin-right: 24px;
		// .el-image{
		// 	width: 16px;
		// }
		::v-deep .el-input {
			width: 400px;
			height: 100%;
			border: none;
			padding-left: 16px;
		}
		::v-deep .el-input__inner {
			text-align: left;
			width: 100%;
			height: 100%;
			line-height: 0.78rem;
			background: transparent;
			border: none;
			font-size: 16px;
			padding: 0;
			&::placeholder {
				color: #A8A8A8;
			}
			&:focus {
				border-color: transparent;
				box-shadow: none;
			}
		}
	}
}
.action-bar1 {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	.submit-btn {
		width: 1.16rem;
		height: 0.50rem;
		border-radius: 0.10rem;
		font-size: 0.18rem;
		font-weight: 500;
		transition: opacity 0.25s ease, transform 0.15s ease;
	
		&:hover {
			opacity: 0.90;
			transform: translateY(-0.01rem);
		}
	
		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
}

::v-deep .el-date-editor--daterange {
	justify-content: center;
}

/* ================================================================
   添加唛头弹窗样式
   ================================================================ */

::v-deep .add-mark-dialog {
	border-radius: 8px;
	overflow: hidden;

	.el-dialog__header {
		padding: 0;
		margin: 0;
	}

	.el-dialog__body {
		padding: 30px 32px 20px;
		padding-bottom: 32px;
	}

	.el-dialog__footer {
		padding: 0 32px 28px;
	}
}


/* ---- 弹窗头部 ---- */
.dialog-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 69px;
	background: #f7fafc;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 30px;
	box-sizing: border-box;
}

.dialog-title {
	font-family: 'PingFang SC', sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	line-height: 1;
}

.dialog-title1 {
	font-family: 'PingFang SC', sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	line-height: 1;
	text-align: center;
}

.dialog-close-icon {
	width: 16px;
	height: 16px;
	cursor: pointer;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.7;
	}
}


/* ---- 弹窗内容区 ---- */
.dialog-body {
	display: flex;
	flex-direction: column;
}


/* 表单字段行 */
.form-field {
	display: flex;
	align-items: center;
	margin: auto;
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}


/* 字段标签 */
.field-label {
	width: 80px;
	text-align: right;
	font-size: 16px;
	font-weight: 400;
	color: #9A9DA7;
	flex-shrink: 0;
	line-height: 45px;
	margin-right: 14px;

	&--center {
		text-align: center;
	}
}


/* 输入框 */
.field-input {
	width: 307px;
	
	.el-input__inner {
		height: 41px;
		line-height: 41px;
		border: 2px solid #E8EDF4;
		border-radius: 8px;
		font-size: 16px;
		color: #333333;
		padding: 0 16px;

		&::placeholder {
			color: #999999;
		}

		&:focus {
			border-color: #0096FF;
		}
	}
}

/* ---- 图片上传区域 ---- */
.form-field--upload {
	align-items: flex-start;

	.upload-container {
		flex: 1;
		width: 307px;
		display: flex;
		flex-wrap: wrap;
		
		::v-deep .el-upload--picture-card {
			width: 90px;
			height: 90px;
			border-radius: 8px;
			border: 1px dashed #DCDFE6;
			background: #FAFAFA;
			line-height: normal;
			display: flex;
			align-items: center;
			justify-content: center;

			&:hover {
				border-color: #0096FF;
				background: #F0F9FF;
			}

			i {
				font-size: 24px;
				color: #C0C4CC;
			}
		}

		::v-deep .el-upload-list--picture-card .el-upload-list__item {
			width: 90px;
			height: 90px;
			border-radius: 8px;
			margin-right: 10px;
			margin-bottom: 10px;
		}
	}

	.upload-tip {
		margin-top: 8px;
		font-size: 12px;
		color: #999999;
		line-height: 1.5;
	}
}

/* 顶部对齐标签 */
.field-label--top {
	line-height: normal;
	padding-top: 8px;
}

/* ---- 弹窗底部按钮区 ---- */
.dialog-footer {
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 4px;
}


/* 返回按钮 */
.btn-cancel {
	width: 120px;
	height: 44px;
	background: #E9F6FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #0096FF;
	cursor: pointer;
	outline: none;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.85;
	}

	&:active {
		opacity: 1;
	}
}

/* 确认修改按钮 */
.btn-confirm {
	width: 120px;
	height: 44px;
	background: #0096FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #FFFFFF;
	cursor: pointer;
	outline: none;
	margin-left: 14px;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.88;
	}

	&:active {
		opacity: 1;
	}
}
.goodsMsg{
	width: 100%;
	height: 100%;
	text-align: left;
	.table-header-row {
		display: flex;
		align-items: center;
	}
	.store-avatar {
		width: 18px;
		height: 18px;
	}
	.store-tag {
		display: inline-block;
		font-size: 12px;
		text-align: center;
		font-weight: 400;
		padding: 0 4px;
		transform: translateY(-1px);
		line-height: normal;
		border-radius: 3px;
		margin-right: 6px;
	}
	.tag-orange {
		border: 1px solid #FF7120;
		background: #FFF5E9;
		color: #FF7120;
	}
	.tag-red {
		border: 1px solid #FC3C3C;
		background: #FFE9E9;
		color: #FC3C3C;
	}
	.tag-blue {
		border: 1px solid #0096FF;
		background: #E9F5FF;
		color: #0096FF;
	}
	.store-tag .el-image {
		width: 14px;
		height: 14px;
	}
	.store-tag-text {
		font-size: 10px;
		color: #FC3C3C;
		font-weight: 400;
		margin-left: 2px;
	}
	.store-name-text {
		font-size: 14px;
		font-weight: 500;
		color: #333;
		margin-left: 8px;
	}
	.table-body {
		display: flex;
		align-items: center;
		padding: 0px 24px;
	}
	.product-img {
		width: 72px;
		height: 72px;
		border-radius: 6px;
		flex-shrink: 0;
		cursor: pointer;
	}
	.product-info {
		flex: 1;
		margin-left: 12px;
	}
	.product-name {
		font-size: 14px;
		font-weight: 500;
		color: #333;
		margin-top: 4px;
	}
	.product-spec {
		font-size: 14px;
		color: #7A7A7A;
		font-weight: 400;
		margin-top: 4px;
	}
	.product-qty {
		font-size: 14px;
		font-weight: 500;
		color: #666;
		flex-shrink: 0;
		text-align: right;
		margin-right: 30px;
	}
	.product-price {
		color: #FC3C3C;
		flex-shrink: 0;
		text-align: right;
	}
	.p-price-symbol {
		font-size: 12px;
		font-weight: 500;
		font-family: 'MiSans', sans-serif;
	}
	.p-price-value {
		font-size: 20px;
		font-weight: 600;
		font-family: 'MiSans', sans-serif;
	}
}

// 新版表格
.newTable{
	.title{
		width: 100%;
		height: 57px;
		border: 1px solid #F0F0F0;
		background: #FAFAFA;
		border-radius: 8px;
		color: #333333;
		font-size: 14px;
		*{
			color: #333333;
		}
		.t1{
			font-size: 14px;
			width: 640px;
			padding-left: 33px;
		}
		.t2{
			text-align: center;
			width: 300px;
		}
		.t3{
			text-align: center;
			width: 160px;
		}
		.t4{
			text-align: center;
			width: 160px;
		}
		.t5{
			text-align: center;
			width: 140px;
		}
		.t6{
			text-align: center;
			width: 300px;
		}
	}
	.goodsItem{
		margin-top: 20px;
		border: 1px solid #F0F0F0;
		border-radius: 20px;
		width: 100%;
		.topBox{
			height: 70px;
			width: 100%;
			border-bottom: 1px solid #F0F0F0;
			padding: 0 24px;
			*{
				color: #333333;
			}
			.sn{
				margin-right: 32px;
				p{
					font-size: 16px;
				}
				.el-image{
					width: 22px;
					height: 22px;
					display: block;
					margin-left: 12px;
				}
			}
			.time{
				font-size: 16px;
				margin-right: 32px;
			}
			.ftype{
				font-size: 16px;
			}
		}
		.gmsg{
			padding: 24px 0;
			.b1{
				width: 480px;
				width: 640px;
			}
			.b2{
				width: 300px;
				font-size: 16px;
				text-align: center;
				color: #333333;
			}
			.b3{
				text-align: center;
				font-size: 16px;
				width: 160px;
				color: #333333;
			}
			.b4{
				text-align: center;
				font-size: 16px;
				width: 160px;
				color: #FC3C3C;
			}
			.b5{
				text-align: center;
				font-size: 16px;
				width: 140px;
				color: #0096FF;
			}
			.b6{
				text-align: center;
				width: 300px;
				div{
					cursor: pointer;
				}
				.btn1{
					width: 144px;
					height: 32px;
					border-radius: 4px;
					border: 1px solid #0096FF;
					font-size: 14px;
					color: #0096FF;
					text-align: center;
					line-height: 32px;
					margin: auto;
					margin-bottom: 6px;
				}
				.btn2{
					width: 144px;
					height: 32px;
					border-radius: 4px;
					border: 1px solid #FC3C3C;
					font-size: 14px;
					color: #FC3C3C;
					text-align: center;
					line-height: 32px;
					margin: auto;
					margin-bottom: 6px;
				}
				.btn3{
					width: 144px;
					height: 32px;
					border-radius: 4px;
					border: 1px solid #DDDFE5;
					font-size: 14px;
					color: #606266;
					text-align: center;
					line-height: 32px;
					margin: auto;
				}
			}
		}
	}
	
}

</style>
